// Ensure this function is called by your alternate checkout button, e.g., <button onclick="handleDeptCheckout()">Department Checkout</button>

function handleDeptCheckout() {
    // 1. Fetch current cart contents using Shopify's AJAX API
    fetch('/cart.js')
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json(); // Parse the response as JSON
        })
        .then(cart => {
           // console.log('Current Cart Contents (with attributes):', cart); // Log cart data for debugging

            if (!cart || !cart.items || cart.items.length === 0) {
                alert('Your cart is empty. Please add items before proceeding with a department checkout.');
                return; // Stop the function if the cart is empty
            }

            // 2. Prepare data to send to your App Proxy
            // The 'cart' object will automatically include 'attributes' if they exist.
            const dataToSend = {
                cart: cart,
                // You can add other top-level info if needed, but 'cart' should contain attributes
            };

            // 3. Send the cart data to your Shopify App Proxy via AJAX (POST request)
            const appProxyEndpoint = '/apps/fetc/dept_order_email.php'; // IMPORTANT: Update this to your actual proxy path

            fetch(appProxyEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(dataToSend)
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`App Proxy error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(proxyResponse => {
                console.log('App Proxy Response:', proxyResponse);
                if (proxyResponse.success) {
                 
                    alert('Department order email successfully initiated!');
                } else {
                    alert('Failed to send department order email: ' + (proxyResponse.message || 'Unknown error.'));
                }
            })
            .catch(error => {
                console.error('Error during department checkout process:', error);
                alert('An error occurred during department checkout. Please try again.');
            });

        })
        .catch(error => {
            console.error('Error fetching cart contents:', error);
            alert('Could not retrieve cart contents. Please check your internet connection or try again later.');
        });
}

